import { colors } from 'parameters/ui'
import { DomainTheme } from 'components/patterns/themes/context/ThemeProvider'

export const UnexecutedSearchTheme: DomainTheme = {
	card: {
		border: `2px solid ${colors.primaryPurple2}`,
		background: { type: 'gradient', start: '#f9f2ff', end: '#ffffff' }
	},
	icon: {
		primaryFill: colors.primaryPurple1
	}
}

export const ExecutedSearchTheme: DomainTheme = {
	card: {
		border: `2px solid ${colors.primaryPurple2}`,
		background: { type: 'gradient', start: '#D6FFED', end: '#FFFFFF' }
	},
	icon: {
		primaryFill: colors.secondaryGreen1
	}
}
